import { lazyLoad } from 'utils/loadable';

export const LeadNurturingTasksPage = lazyLoad(
  () => import('./index'),
  module => module.default,
);
